var _circle, _circle2, _path, _circle3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirportIconTrike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 80.4,
    r: 3.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 76.3,
    r: 3.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6 32.8 8.3 22.2c-.8-.1-1.6.2-2.1.9s-.6 1.6-.2 2.4l9.9 20.9-5.1.9c-1.2.2-2.1 1.4-1.8 2.7s1.4 2.1 2.7 1.8l8-1.5 15.1-2.8 2.5 13.6-1.9.3L34 54c-.1-.4-.5-.7-.9-.6-.4.1-.7.5-.6.9l1.4 7.6c-.8.5-1.2 1.4-1 2.3s.9 1.6 1.8 1.8l1.4 7.8c.1.4.5.7.9.6s.7-.5.6-.9L36.2 66l.6-.1c2.1 5.7 8.1 9.2 14.3 8.1L63 71.8c1.2-.2 2.1-1.4 1.8-2.7-.2-1.2-1.4-2.1-2.7-1.8l-11.9 2.2c-4.5.8-8.8-2.2-9.6-6.6-.2-1-.9-1.7-1.8-1.8l-2.5-13.7 54.3-9.9c1.1-.2 1.9-1.2 1.9-2.3 0-1.3-.8-2.2-1.9-2.4zM20.5 45.5l-8.6-18.2 63.5 8.2-54.9 10z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.7,
    cy: 55.2,
    r: 3.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m50.8 68.4 7.5-1.4c1.2-.2 2.1-1.4 1.8-2.7-.2-1.2-1.4-2.1-2.7-1.8L50 63.9c-2 .3-3.8-.9-4.2-2.9-.2-1.2-1.4-2.1-2.7-1.8-1.2.2-2.1 1.4-1.8 2.7.8 4.3 5.1 7.3 9.5 6.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportIconTrike);
export default __webpack_public_path__ + "static/media/airport_icon_trike.05cc99004ae0cd7ed9bf95bb73a277d7.svg";
export { ForwardRef as ReactComponent };